export interface GlobalNotification {
  id: string;
  message: string;
  type: NotificationType;
  duration?: number; // temporary notifications only
  template?: any;
  isPersistent?: boolean;
  translate?: boolean;
  animationState?: 'start' | 'end';
  isStacked?: boolean;
  stackIndex?: number;
  created_at?: string; // persistant notifications only
  shown?: number; // persistant notifications only, 0 - not shown, 2 - shown
  link?: string; // persistant notifications only
}

export type NotificationType = 'success' | 'danger' | 'warning' | 'info';

export const NotificationTypes = ['success', 'danger', 'warning', 'info'] as const;
